import join from 'url-join';

import { TransferType } from '@app/common/types/enum/transferType';
import { COMMON_PAGES } from '@app/common/utils/constants';

import {
  ChannelId,
  MakeTransferFormField as FormFields,
} from '@make-transfer/types/common';

import { getChannelRoute } from './routing';

// Make transfer constants
const ACH = getChannelRoute(ChannelId.ACH);
const CHECKWITHDRAWAL = getChannelRoute(ChannelId.CheckWithdrawal);
const EXTERNAL = getChannelRoute(ChannelId.External);
const INTERNAL = getChannelRoute(ChannelId.Internal);
const INVESTMENT = getChannelRoute(ChannelId.Investment);
const M2M = getChannelRoute(ChannelId.M2M);
const P2P = getChannelRoute(ChannelId.P2P);
const SKIP = getChannelRoute(ChannelId.Skip);
const STOPCHECK = getChannelRoute(ChannelId.StopCheck);
const WIRE = getChannelRoute(ChannelId.Wire);
const PAYBYCARD = getChannelRoute(ChannelId.PayByCard);
const INVOICES = getChannelRoute(ChannelId.Invoices);

const MANAGE_PAYEES = join(M2M, 'manage-payees');
const ACH_FILE = join(ACH, 'file');
const WIRE_NEW = join(WIRE, 'new');
const WIRE_SEND = join(WIRE, 'send');
const WIRE_EDIT = join(WIRE, 'edit');
const WIRE_NEW_BANK = join(WIRE_NEW, 'bank');
const WIRE_NEW_INFO = join(WIRE_NEW, 'info');
const PAY_BY_CARD_NEW = join(PAYBYCARD, 'new');
const PAY_BY_CARD_SEND = join(PAYBYCARD, 'send');
const SEND_INVOICE = join(INVOICES, 'send', 'new');

// instead of enum, cause can't use computed values as value for enum keys
export const MakeTransferPages = {
  ROOT: COMMON_PAGES.MAKE_TRANSFER,
  ACH,
  ACH_FILE,
  CHECKWITHDRAWAL,
  EXTERNAL,
  INTERNAL,
  INVESTMENT,
  M2M,
  MANAGE_PAYEES,
  P2P,
  SKIP,
  STOPCHECK,
  WIRE,
  WIRE_NEW,
  WIRE_NEW_BANK,
  WIRE_NEW_INFO,
  WIRE_SEND,
  WIRE_EDIT,
  PAYBYCARD,
  PAY_BY_CARD_NEW,
  PAY_BY_CARD_SEND,
  INVOICES,
  SEND_INVOICE,
};

// TODO: Should remove
export const makeTransferDefaultFormState = {
  [FormFields.FROM]: null,
  [FormFields.TO]: null,
  [FormFields.AMOUNT]: '',
  [FormFields.TRANSFER_TYPE]: TransferType.SEND_NOW,
  [FormFields.PAYMENT_OPTION]: null,
  [FormFields.MEMO]: '',
  [FormFields.AGREEMENT_ACCEPTED]: false,
};
